import AbstractType from "@/application/typeConfig/AbstractTypeConfig.ts";
import {RouteEnum} from "@/router/RouteEnum.ts";
import type {StepperItem} from "@/domain/type/config.type.ts";
import router from "@/router/router.ts";
import {Source} from "@/domain/type/source.type.ts";
import {SynchroType} from "@/domain/type/synchro.type.ts";
import {useWorkflowStore} from "@/stores/workflow.store.ts";
import {useSynchroStore} from "@/stores/synchro.store.ts";


export default class PersonConfig extends AbstractType {
  private workflowStore = useWorkflowStore()
  private synchroStore = useSynchroStore()

  getStepperItems(): StepperItem[] {
    return [
      {
        disabled: false,
        route: RouteEnum.FusionCompany,
        icon: "mdi-bank",
        title: "Société",
        action: () => router.push(this.getRoute(RouteEnum.FusionCompany))
      },
      {
        disabled: () => this.disableCollaborators(),
        route: RouteEnum.SyncWithOwner,
        icon: "mdi-account-multiple",
        title: "Collaborateurs",
        action: () => router.push(this.getRoute(RouteEnum.SyncWithOwner))
      }
    ];
  }

  cleanFieldValue(value: string, label: string): string {
    return value;
  }

  sourceLeftList(): Source[] {
    return [Source.EVA];
  }

  sourceRightList(): Source[] {
    return [Source.AMMON];
  }

  private disableCollaborators() {
    if (router.currentRoute.value.name === RouteEnum.FusionCompany) {
      if (this.synchroStore.details?.src1.length === 0) {
        return true
      }
      if (![Source.AMMON, Source.EVA].includes(this.synchroStore.sourceRight)) {
        return true
      }
      if (![Source.AMMON, Source.EVA].includes(this.synchroStore.sourceLeft)) {
        return true
      }
    }
    return false;
  }

  private getRoute(routeName: RouteEnum): any {
    switch (routeName) {
      case RouteEnum.FusionCompany:
        return {
          name: RouteEnum.FusionCompany,
          params: {
            sourceLeft: this.synchroStore.sourceLeft,
            sourceRight: this.synchroStore.sourceRight,
            id: this.workflowStore.companyId
          },
          query: {
            _r: Date.now()
          }
        }
      case RouteEnum.SyncWithOwner:
        return {
          name: RouteEnum.SyncWithOwner,
          params: {
            ownerId: this.workflowStore.companyId,
            type: SynchroType.PERSONS
          }
        }
    }
  }
}
